module.exports = __webpack_public_path__ + "img/markerY.759eefff.png";